import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Img from "react-cool-img";
import earn from "../../../assets/staticAssets/earn_2.svg";

function LandingPageTenthSection() {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  const faqs = [
    {
      question: "Can I trade in INR on PocketBits?",
      answer: (
        <p>Yes, you can directly deposit and trade with INR on PocketBits.</p>
      ),
    },
    {
      question: "How secure is PocketBits?",
      answer: (
        <p>
          90% of all user funds are stored in a Cold storage and are processed
          manually, hence funds are always secure even if by chance the systems
          are ever compromised or down. PocketBits has learned from years of
          experience and inbibes security in all of its core infrastructure
          including storing user data.
        </p>
      ),
    },
    {
      question: "What is a closed & open order book?",
      answer: (
        <p>
          The order book is the list of all open orders that are currently
          available on an exchange for a specific asset. An open order is
          essentially another trader willing to buy or sell an asset at a
          specific price. Placing an order does not guarantee someone else will
          agree to take the offer. PocketBits offers a closed order book crypto
          trading experience wherein PocketBits is the counterparty to your
          trade and is always available to Buy or Sell with best prices in the
          market.Thus Instant and Easy.
        </p>
      ),
    },
    {
      question: "What is slippage?",
      answer: (
        <p>
          In an open order book buyers need to match buy orders with multiple
          sell orders placed by sellers at various prices on the order book,
          eventually increasing the actual buy price & vice versa for sellers.
          Slippage refers to the difference between the expected price of a
          trade and the price at which the trade is executed. On PocketBits we
          have 0% slippage and you can buy upto 10 Lakhs INR at the same price,
          what you see is what you get.
        </p>
      ),
    },
    {
      question: "How long does it take to approve the KYC?",
      answer: (
        <p>
          KYC verification requests are verified in a maximum of 59 minutes, if
          all details provided are in order.
        </p>
      ),
    },
    {
      question: "How do I earn without trading?",
      answer: (
        <p>
          You can earn without even trading by referring your friends to
          PocketBits and get 0.1% of the value of their trades as a reward*. You
          can even hold your crypto assets in our VAULT and earn upto 16.5% APY.
        </p>
      ),
    },
  ];
  return (
    <div className=" pb-20 md:mb-0 md:-mt-10  overflow-hidden bg-gradient-to-b from-[#131517]">
      <div className="container-bt">
        <div className="">
          <div className=" leading-relaxed">
            <h1 className="font-extrabold mb-10">FAQs</h1>
          </div>
          <div className="flex items-center flex-col">
            {faqs.map((ele, idx) => (
              <Accordion
                className="rounded-lg overflow-hidden mb-3 md:w-[800px] w-full"
                defaultExpanded={idx == 0 ? true : false}
              >
                <AccordionSummary
                  expandIcon={
                    <Img
                      className=""
                      style={{ width: "24px", height: "24px" }}
                      src={
                        require("../../../assets/optimized/Landing/FAQ/faqDropdownDown.svg")
                          .default
                      }
                    />
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    background:
                      "radial-gradient(132.67% 15236.89% at 36.33% 26.36%, rgba(92, 98, 112, 0.234) 0%, rgba(24, 27, 35, 0.3) 100%), linear-gradient(92.72deg, rgba(92, 98, 112, 0.4) -29.97%, rgba(23, 27, 35, 0) 233.47%)",
                  }}
                >
                  <h3 className="font-normal">{ele.question}</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    className="text-sm md:text-lg font-light leading-relaxed"
                    style={{ color: "#ccc" }}
                  >
                    {ele.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({}));
export default LandingPageTenthSection;
